import { gql } from '@apollo/client';

/** api_version=4 且已配 openapi 凭证的渠道（含 appKey/appSecret，运维签名调试用） */
export const GET_SORTER_API_CREDENTIALS = gql`
    query GetSorterApiCredentials {
        getSorterApiCredentials {
            channelId
            channelName
            apiVersion
            appKey
            appSecret
        }
    }
`;

export interface SorterApiCredential {
    channelId: number;
    channelName: string;
    apiVersion: number | null;
    appKey: string;
    appSecret: string;
}

export interface GetSorterApiCredentialsData {
    getSorterApiCredentials: SorterApiCredential[];
}

/** 全部分拣机（machineCode 下拉用） */
export const GET_SORTER_MACHINE_OPTIONS = gql`
    query GetSorterMachineOptions {
        getSorterMachineOptions {
            sorterCode
            sorterName
            warehouseId
            sorterType
        }
    }
`;

export interface SorterMachineOption {
    sorterCode: string;
    sorterName: string | null;
    warehouseId: number;
    sorterType: number;
}

export interface GetSorterMachineOptionsData {
    getSorterMachineOptions: SorterMachineOption[];
}
